import { Component, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogModule,
  DynamicDialogRef,
} from 'primeng/dynamicdialog';

@Component({
  selector: 'app-comfirmation-modal',
  standalone: true,
  imports: [CommonModule, ButtonModule, DynamicDialogModule],
  templateUrl: './confirmation-modal.component.html',
})
export class ConfirmationModalComponent implements OnInit {
  ref: DynamicDialogRef | undefined;

  message: string = this.config.data.message;

  constructor(
    public dialogService: DialogService,
    public dialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig,
  ) {}
  ngOnInit(): void {}

  closeDialog(isOk: boolean) {
    this.dialogRef.close(isOk);
  }
}
